<div [formGroup]="formSearch">
  <div class="mb-3 flex justify-between items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Codigo tg</mat-label>
      <input matInput formControlName="tgCode" />
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Codigo OS</mat-label>
      <input matInput formControlName="osCode" />
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Cliente</mat-label>
      <input matInput formControlName="client" readonly />
      <button mat-icon-button matSuffix (click)="addClient()">
        <mat-icon>add</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Serviço</mat-label>
      <input matInput formControlName="service" />
    </mat-form-field>
  </div>
  <div class="mb-3 flex justify-between items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Origem</mat-label>
      <input matInput formControlName="origin" />
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Destino</mat-label>
      <input matInput formControlName="destination" />
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Tipo Veículo</mat-label>
      <mat-select formControlName="vehicleType">
        <mat-option [value]="''">Todos</mat-option>
        @for (vehicleType of vehicleTypes; track vehicleType.id) {
          <mat-option [value]="vehicleType.id">{{ vehicleType.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-3/12"
      appearance="outline"
    >
      <mat-label>Tipo Motorista</mat-label>
      <mat-select formControlName="driverType">
        <mat-option [value]="''">Todos</mat-option>
        @for (driverType of driverTypes; track driverType.id) {
          <mat-option [value]="driverType.id">{{ driverType.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="mb-3 flex justify-between items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Status da OS</mat-label>
      <mat-select formControlName="statusOsId">
        <mat-option [value]="''">Todos</mat-option>
        @for (status of statusOsList; track status.id) {
          <mat-option [value]="status.id">{{ status.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Consultor Operacional</mat-label>
      <input matInput formControlName="consultant" readonly />
      <button mat-icon-button matSuffix (click)="addConsultanOperational()">
        <mat-icon>add</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-4/12"
      appearance="outline"
    >
      <mat-label>Fornecedor Atribuído Por</mat-label>
      <mat-select formControlName="fornecedorAtribuidoPor">
        <mat-option [value]="''">Todos</mat-option>
        @for (consultor of consultoresAtribuicao; track consultor.id) {
          <mat-option [value]="consultor.id">{{ consultor.nome }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="mb-3 flex justify-between items-center gap-3">
    <mat-form-field
      class="input-tg search-tg no-message-new w-6/12"
      appearance="outline"
    >
      <mat-label>Data inicio</mat-label>
      <input
        matInput
        [matDatepicker]="dateStart"
        (focus)="openDatepicker('dateStart')"
        formControlName="dateStart"
        readonly
        [max]="formSearch.get('dateEnd')!.value"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="dateStart"
      ></mat-datepicker-toggle>
      <mat-datepicker #dateStart></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="input-tg search-tg no-message-new w-6/12"
      appearance="outline"
    >
      <mat-label>Data fim</mat-label>
      <input
        matInput
        [matDatepicker]="dateEnd"
        (focus)="openDatepicker('dateEnd')"
        formControlName="dateEnd"
        readonly
        [min]="formSearch.get('dateStart')!.value"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="dateEnd"
      ></mat-datepicker-toggle>
      <mat-datepicker #dateEnd></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="mb-3 flex justify-end items-center gap-2">
    <button
      class="btn-icon"
      (click)="sendSearch(false)"
      [matTooltip]="'Limpar Pesquisar'"
    >
      <mat-icon>replay</mat-icon>
    </button>
    <button class="btn-icon" (click)="sendSearch()" [matTooltip]="'Pesquisa'">
      <mat-icon>search</mat-icon>
    </button>
  </div>
</div>
